/* ============================================================
   BELLA NOTTE · v17 — שמירת פריטים ("אהבתי").

   עצמאי לחלוטין: localStorage בלבד. לא נוגע בעגלה, במלאי,
   במנגנון המתנה, באפסייל או בחשבון הלקוחה. אם localStorage
   חסום (גלישה פרטית) הכל נכשל בשקט ושאר האתר ממשיך כרגיל.

   ההוספה לעגלה מתוך הרשימה יושבת בקובץ נפרד: bn-wish-cart.js.

   שלוש נקודות שחשוב לא לשבור אם נוגעים כאן:

   1. מאזינים לקליק בשלב ה-capture על document. זה בכוונה:
      product-card.js מאזין על אלמנט הכרטיס ומנווט לדף המוצר.
      capture רץ לפניו, ולכן stopPropagation כאן עוצר את הניווט.

   2. כל הקליקים עוברים דרך האחד הזה, לפי data attributes — ולא
      דרך מאזינים שמוצמדים לאלמנטים. התבנית מרנדרת מחדש סקשנים
      ומחליפה צומתי DOM, וכל מאזין שמוצמד לצומת נאבד איתו.

   3. ה-MutationObserver מעדכן טקסט רק אם הוא באמת השתנה.
      כתיבת textContent זהה היא עדיין מוטציה של childList, והיא הייתה
      מפעילה את ה-observer שוב ושוב — לולאה אינסופית.
   ============================================================ */

(function () {
  if (window.__bnWish) return;
  window.__bnWish = true;

  var KEY = 'bn_wish_v1';
  var HEART =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 20.5l-1.4-1.3C5.9 15 2.8 12.2 2.8 8.7 2.8 5.9 5 3.7 7.8 3.7c1.6 0 3.1.7 4.2 2 1.1-1.3 2.6-2 4.2-2 2.8 0 5 2.2 5 5 0 3.5-3.1 6.3-7.8 10.5L12 20.5z"/>' +
    '</svg>';

  /* ---------- אחסון ---------- */

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function findIndex(list, id) {
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* ---------- סנכרון תצוגה ---------- */

  function syncHearts() {
    var list = read();
    var nodes = document.querySelectorAll('[data-bn-wish]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var on = findIndex(list, el.getAttribute('data-bn-wish-id')) > -1;
      if (el.classList.contains('bn-wish--on') !== on) el.classList.toggle('bn-wish--on', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      el.setAttribute('aria-label', on ? 'הסרה מהפריטים ששמרת' : 'שמירת הפריט');
    }
    syncCount();
  }

  function syncCount() {
    var n = read().length;
    var txt = n ? String(n) : '';
    var badges = document.querySelectorAll('.bn-wishb__count');
    for (var i = 0; i < badges.length; i++) {
      /* רק אם השתנה — אחרת ה-observer נכנס ללולאה */
      if (badges[i].textContent !== txt) badges[i].textContent = txt;
      if (n) badges[i].removeAttribute('hidden');
      else badges[i].setAttribute('hidden', '');
    }
  }

  /* ---------- כפתור בכותרת ---------- */

  function mountTrigger() {
    var actions = document.querySelector('header-actions');
    if (!actions || actions.querySelector('.bn-wishb')) return;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'header-actions__action button-unstyled bn-wishb';
    btn.setAttribute('data-bn-wish-open', '');
    btn.setAttribute('aria-label', 'הפריטים ששמרת');
    btn.innerHTML = HEART + '<span class="bn-wishb__count" hidden></span>';

    var cart = actions.querySelector('[data-testid="cart-drawer-trigger"]');
    if (cart && cart.parentElement === actions) actions.insertBefore(btn, cart);
    else actions.appendChild(btn);

    syncCount();
  }

  /* ---------- חלון הפריטים ---------- */

  function panelEl() {
    var p = document.getElementById('bn-wish-panel');
    if (p) return p;

    p = document.createElement('div');
    p.id = 'bn-wish-panel';
    p.className = 'bn-wishp';
    p.setAttribute('hidden', '');
    p.innerHTML =
      '<div class="bn-wishp__veil" data-bn-wish-close></div>' +
      '<div class="bn-wishp__card" role="dialog" aria-modal="true" aria-label="הפריטים ששמרת" dir="rtl">' +
      '<div class="bn-wishp__head">' +
      '<p class="bn-wishp__title">הפריטים ששמרת</p>' +
      '<button type="button" class="bn-wishp__x" data-bn-wish-close aria-label="סגירה">×</button>' +
      '</div>' +
      '<div class="bn-wishp__body"></div>' +
      '</div>';

    document.body.appendChild(p);
    return p;
  }

  function renderPanel() {
    var body = panelEl().querySelector('.bn-wishp__body');
    var list = read();

    if (!list.length) {
      body.innerHTML =
        '<p class="bn-wishp__empty">עוד לא שמרת פריטים.<br>לחצי על הלב שעל השמלה כדי לשמור אותה כאן.</p>';
      return;
    }

    var html = '';
    for (var i = 0; i < list.length; i++) {
      var it = list[i];
      html +=
        '<div class="bn-wishp__item" data-bn-item="' + esc(it.id) + '">' +
        '<div class="bn-wishp__row">' +
        '<a class="bn-wishp__thumb" href="' + esc(it.url) + '">' +
        (it.img ? '<img src="' + esc(it.img) + '" alt="" loading="lazy">' : '') +
        '</a>' +
        '<div class="bn-wishp__info">' +
        '<a class="bn-wishp__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
        '<span class="bn-wishp__price">' + esc(it.price) + '</span>' +
        '</div>' +
        '<button type="button" class="bn-wishp__add" data-bn-wish-add="' + esc(it.id) + '"' +
        ' data-bn-wish-url="' + esc(it.url) + '" aria-label="הוספה לעגלה">+</button>' +
        '<button type="button" class="bn-wishp__rm" data-bn-wish-rm="' + esc(it.id) + '" aria-label="הסרת הפריט">×</button>' +
        '</div>' +
        '<div class="bn-wishp__pick" hidden></div>' +
        '</div>';
    }
    body.innerHTML = html;
  }

  function openPanel() {
    var p = panelEl();
    renderPanel();
    p.removeAttribute('hidden');
    /* setTimeout ולא requestAnimationFrame: rAF לא נורה כשהלשונית ברקע,
       ואז החלון נשאר שקוף לגמרי. */
    setTimeout(function () {
      p.classList.add('bn-wishp--open');
    }, 16);
  }

  function closePanel() {
    var p = document.getElementById('bn-wish-panel');
    if (!p) return;
    p.classList.remove('bn-wishp--open');
    setTimeout(function () {
      p.setAttribute('hidden', '');
    }, 240);
  }

  /* ---------- אירועים ---------- */

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      if (t.closest('[data-bn-wish-open]')) {
        e.preventDefault();
        e.stopPropagation();
        openPanel();
        return;
      }

      if (t.closest('[data-bn-wish-close]')) {
        e.preventDefault();
        closePanel();
        return;
      }

      var rm = t.closest('[data-bn-wish-rm]');
      if (rm) {
        e.preventDefault();
        e.stopPropagation();
        var list = read();
        var i = findIndex(list, rm.getAttribute('data-bn-wish-rm'));
        if (i > -1) {
          list.splice(i, 1);
          write(list);
        }
        renderPanel();
        syncHearts();
        return;
      }

      var heart = t.closest('[data-bn-wish]');
      if (!heart) return;

      /* עוצר את הניווט של product-card.js */
      e.preventDefault();
      e.stopPropagation();

      var id = heart.getAttribute('data-bn-wish-id');
      var l = read();
      var idx = findIndex(l, id);

      if (idx > -1) {
        l.splice(idx, 1);
      } else {
        l.unshift({
          id: id,
          title: heart.getAttribute('data-bn-wish-title') || '',
          url: heart.getAttribute('data-bn-wish-url') || '',
          img: heart.getAttribute('data-bn-wish-img') || '',
          price: heart.getAttribute('data-bn-wish-price') || ''
        });
        heart.classList.add('bn-wish--pop');
        setTimeout(function () {
          heart.classList.remove('bn-wish--pop');
        }, 440);
      }

      write(l);
      syncHearts();

      var p = document.getElementById('bn-wish-panel');
      if (p && !p.hasAttribute('hidden')) renderPanel();
    },
    true
  );

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  /* שינוי בלשונית אחרת — מסנכרנים */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY) syncHearts();
  });

  /* ---------- רינדורים מחדש של התבנית ---------- */

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () {
      pending = null;
      mountTrigger();
      syncHearts();
    }, 140);
  }

  function boot() {
    mountTrigger();
    syncHearts();
    try {
      new MutationObserver(schedule).observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  setTimeout(schedule, 400);
  setTimeout(schedule, 1400);
})();
